module.exports = "/_next/static/images/a0f1f8ee106da1994013ed0e8e8248e7-money.svg";